import { IDistrict, IqueryParams } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

type District = {
  name: string;
  region_id: string;
};

interface ExportParams extends IqueryParams<{
  district_name?: string;
  region_name?: string;
}> {
  file_format: 'pdf' | 'csv';
}

const createDistrict = async (data: District) => {
  return apiService.apiRequest<IDistrict>("post", `districts`, data);
};

const getDistricts = async (queryParams?: IqueryParams<{
  district_name?: string;
  region_name?: string;
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IDistrict[]>("get", `districts${query}`);
};

const getDistrict = async (district_id: string) => {
  return apiService.apiRequest<IDistrict>("get", `districts/${district_id}`);
};

const updateDistrict = async (district_id: string, data: District) => {
  return apiService.apiRequest<IDistrict>("put", `districts/${district_id}`, data);
};

const deleteDistrict = async (district_id: string) => {
  return apiService.apiRequest<any>("delete", `districts/${district_id}`);
};

const restoreDistrict = async (district_id: string) => {
  return apiService.apiRequest<IDistrict>("get", `districts/${district_id}/restore`);
};

const exportDistricts = async (params: ExportParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `districts/export${query}`
  );
};

export const districsApi = {
  createDistrict,
  getDistricts,
  getDistrict,
  updateDistrict,
  deleteDistrict,
  restoreDistrict,
  exportDistricts, 
};